module.exports = __webpack_public_path__ + "img/default_mavir.45461a57.jpg";